/* eslint-disable import/no-unresolved */
import { shape, bool } from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";
import classNames from "classnames";
import { Box, Hint } from "@ui-kit/components/index.es";

import FormattedAmount from "pages/_components/FormattedAmount";
import FormattedDate from "pages/_components/FormattedDate";

import Heading from "pages/_components/Heading";
import { Col } from "react-bootstrap";

import { selectors as addLimitRequestSelectors } from "reducers/addLimitRequest";
import { isFinalState } from "util/transaction";

import * as configUtils from "util/config";

class AddLimitTransactionData extends Component {
    DEFAULT_MOTIVE_OPTIONS = [
        { value: "transfers", label: "Transferencias Inmediatas" },
        { value: "credin", label: "CREDIN" },
        { value: "debin", label: "DEBIN" },
        { value: "payments", label: "Pago de servicios" },
        { value: "arca", label: "ARCA" },
    ];

    static propTypes = {
        summary: shape({}).isRequired,
        isDesktop: bool.isRequired,
    };

    render() {
        const {
            summary: { idTransaction, reason, temporaryLimit, duration, currency, idTransactionStatus, submitDateTime },
            isDesktop,
        } = this.props;
        const hintText = configUtils.get("frontend.text.temporarilyincreaselimit");

        const motiveOption = this.DEFAULT_MOTIVE_OPTIONS?.find((option) => option.value === reason);
        return (
            <Col xs={12} className="mt-3 px-0">
                {isFinalState(idTransactionStatus) && (
                    <Heading.DataGroup
                        containerClassName={classNames("transaction-ticket-detail data-wrapper-flex space-between", {
                            "mb-2": !isDesktop,
                        })}
                        labelClassName="data-label-medium"
                        dataClassName="data-desc"
                        label="transferSummary.date.label"
                        data={
                            <p className="data-desc m-0">
                                <FormattedDate date={submitDateTime} dateFormat="dd/MM/yyyy" showTime />
                            </p>
                        }
                    />
                )}
                <Heading.DataGroup
                    containerClassName={classNames("transaction-ticket-detail data-wrapper-flex space-between", {
                        "mb-2": !isDesktop,
                    })}
                    labelClassName="data-label-medium"
                    dataClassName="data-desc"
                    label="transferConfirmation.idTransaction.label"
                    data={<p className="data-desc m-0">{idTransaction?.substring(0, 8).toUpperCase()}</p>}
                />

                <Heading.DataGroup
                    containerClassName={classNames("transaction-ticket-detail data-wrapper-flex space-between", {
                        "mb-2": !isDesktop,
                    })}
                    labelClassName="data-label-medium"
                    dataClassName="data-desc"
                    label="addLimitRequest.confirmation.motive"
                    data={<p className="data-desc m-0">{motiveOption?.label}</p>}
                />

                <Heading.DataGroup
                    containerClassName={classNames("transaction-ticket-detail data-wrapper-flex space-between", {
                        "mb-2": !isDesktop,
                    })}
                    labelClassName="data-label-medium"
                    dataClassName="data-desc"
                    label="addLimitRequest.confirmation.temporaryLimit"
                    data={
                        <FormattedAmount
                            currency={currency}
                            quantity={temporaryLimit ? temporaryLimit.replace(".", ",") : "0"}
                            notBold
                        />
                    }
                />

                <Heading.DataGroup
                    containerClassName={classNames("transaction-ticket-detail data-wrapper-flex space-between", {
                        "mb-2": !isDesktop,
                    })}
                    labelClassName="data-label-medium"
                    dataClassName="data-desc"
                    label="addLimitRequest.confirmation.duration"
                    data={<p className="data-desc m-0">{duration} hs</p>}
                />
                <Box px={!isDesktop ? 0 : undefined} my={16}>
                    <Hint text={hintText} iconVariant="fill" size={!isDesktop ? "medium" : "big"} />
                </Box>
            </Col>
        );
    }
}

const mapStateToProps = (state) => ({
    summary: addLimitRequestSelectors.getSummary(state),
});

export default connect(mapStateToProps)(AddLimitTransactionData);
